<template>
	<div class="card mb-10">
		<div class="d-flex align-center mb-2">
			<img
				:src="require(`@/assets/images/${profile}.png`)"
				style="max-width: 25px"
				alt=""
				class="mr-1"
			/>
			<div class="profile d-flex align-center">
				{{ name }}
				<div class="dot"></div>
				<span>{{ job }}</span>
			</div>
		</div>

		<div
			class="comment white-space-pre mb-3"
			:style="language === 'ko' ? 'height: 65px;' : 'height: 85px;'"
		>
			{{ comment }}
		</div>
		<div class="star d-flex align-center">
			5.0
			<img class="ml-1" src="@/assets/images/star-icon.png" alt="" />
		</div>
	</div>
</template>

<script>
export default {
	props: {
		name: { required: true, type: String },
		job: { required: true, type: String },
		comment: { required: true, type: String },
		profile: { required: true, type: String },
	},
	computed: {
		language() {
			return this.$store.getters['language']
		},
	},
}
</script>

<style lang="scss" scoped>
.card {
	// width: 268px;
	padding: 25px 15px 25px 20px;
	border-radius: 10px;
	background-color: #edf4ff;
}
.star {
	font-size: 18px;
	font-weight: 900;
	font-stretch: normal;
	font-style: normal;
	line-height: normal;
	letter-spacing: -0.24px;
	color: #1a1a1a;
}

@media screen and (max-width: 600px) {
	.card {
		// min-height: 110px;
	}
}

.comment {
	font-size: 14px;
	font-weight: normal;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.67;
	letter-spacing: -0.43px;
	color: #1a1a1a;
}

@media screen and (max-width: 600px) {
	.comment {
		font-size: 14px;
		font-weight: 500;
		line-height: 1.5;
		letter-spacing: -0.5px;
	}
}

.dot {
	width: 2px;
	height: 2px;
	margin: 0 5px;
	background-color: #808080;
}

.profile {
	font-size: 12px;
	font-weight: 500;
	letter-spacing: -0.16px;
	color: #1a1a1a;
	span {
		color: #808080;
	}
}
</style>
